// import React, { useEffect, useRef, useState } from "react";
// import { Container, Row, Col } from "react-bootstrap";

// const STAGES = [
//   {
//     num: "01",
//     name: "Acquire",
//     text:
//       "Target growing businesses with operational processes that are highly repetitive, manual, or fragmented. Initial acquisition focuses on direct sales, strategic partnerships, industry-specific marketing, referrals, and targeted digital campaigns."
//   },
//   {
//     num: "02",
//     name: "Activate",
//     text:
//       "Convert initial customers through a limited number of high-value workflows. The goal is to demonstrate measurable value quickly — reduced manual work, faster response times, fewer errors, higher productivity."
//   },
//   {
//     num: "03",
//     name: "Expand",
//     text:
//       "Once the platform is embedded within an organization, introduce additional workflows, AI agents, users, integrations, and departments — increasing revenue per customer and improving retention."
//   },
//   {
//     num: "04",
//     name: "Enterprise",
//     text:
//       "Develop larger enterprise accounts through advanced security, administrative controls, analytics, integrations, dedicated support, and customized AI functionality, increasing contract size and relationship length."
//   }
// ];

// const PROCEEDS = [
//   { label: "Product & AI Development", percent: 40 },
//   { label: "Sales & Marketing", percent: 25 },
//   { label: "Personnel & Operations", percent: 15 },
//   { label: "Enterprise Infrastructure & Security", percent: 10 },
//   { label: "Working Capital & General Corporate Purposes", percent: 10 }
// ];

// const MILESTONES = [
//   { phase: "Months 1–6", text: "Build the Foundation" },
//   { phase: "Months 7–12", text: "Accelerate Customer Acquisition" },
//   { phase: "Months 13–24", text: "Expand the Platform" },
//   { phase: "Months 25–36", text: "Scale the Enterprise Business" }
// ];

// function useInView(threshold = 0.35) {
//   const ref = useRef(null);
//   const [inView, setInView] = useState(false);

//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setInView(true);
//           observer.disconnect();
//         }
//       },
//       { threshold }
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, [threshold]);

//   return [ref, inView];
// }

// function Summary() {
//   const [proceedsRef, proceedsInView] = useInView(0.3);

//   return (
//     <section id="business" style={{ paddingTop: "35px", paddingBottom: "35px" }}>
//       <Container>
//         <div className="section-label">Business Summary</div>
//         <h2 className="section-title">Strategy &amp; Operations</h2>
//         <div className="divider-gold"></div>

//         <Row className="g-4 mt-3">
//           {/* Revenue Growth Strategy */}
//           <Col lg={12}>
//             <div className="business-card fade-up site-box-shadow" style={{borderTop:'solid 2px var(--gold)'}}>
//               <h5 className="nx-eyebrow">Revenue Growth Strategy</h5>
//               <p className="nx-intro">
//                 Nexora's revenue growth strategy is designed around four primary stages.
//               </p>

//               <div className="nx-stage-grid">
//                 {STAGES.map((stage) => (
//                   <div className="nx-stage" key={stage.num}>
//                     <div className="nx-stage-num">{stage.num}</div>
//                     <div className="nx-stage-name">{stage.name}</div>
//                     <p className="nx-stage-text">{stage.text}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </Col>

//           {/* Use of Proceeds */}
//           <Col lg={6}>
//             <div className="business-card fade-up site-box-shadow" ref={proceedsRef} style={{borderTop:'solid 2px var(--gold)'}}>
//               <h5 className="nx-eyebrow">Use of Proceeds</h5>

//               <div style={{ marginTop: "8px" }}>
//                 {PROCEEDS.map(({ label, percent }) => (
//                   <div key={label} className="nx-proceeds-row">
//                     <div className="d-flex justify-content-between align-items-baseline mb-2">
//                       <span className="nx-proceeds-label">{label}</span>
//                       <span className="nx-proceeds-value">{percent}%</span>
//                     </div>
//                     <div className="nx-proceeds-track">
//                       <div
//                         className="nx-proceeds-fill"
//                         style={{ width: proceedsInView ? `${percent}%` : "0%" }}
//                       />
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </Col>

//           {/* Development Milestones */}
//           <Col lg={6}>
//             <div className="business-card fade-up site-box-shadow" style={{borderTop:'solid 2px var(--gold)'}}>
//               <h5 className="nx-eyebrow">Development Milestones</h5>

//               <div className="nx-milestones">
//                 {MILESTONES.map((m, i) => (
//                   <div className="nx-milestone-row" key={m.phase}>
//                     <div className="nx-milestone-marker">
//                       <span className="nx-milestone-dot" />
//                       {i !== MILESTONES.length - 1 && <span className="nx-milestone-line" />}
//                     </div>
//                     <div className="nx-milestone-content">
//                       <div className="nx-milestone-phase">{m.phase}</div>
//                       <div className="nx-milestone-text">{m.text}</div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </Container>

//       <style>{`
//         .nx-eyebrow {
//           font-size: .72rem;
//           letter-spacing: .14em;
//           text-transform: uppercase;
//           color: var(--gold);
//           margin-bottom: 20px;
//           font-family: 'Founders Grotesk', sans-serif;
//           font-weight: 700;
//         }

//         .nx-intro {
//           font-size: .88rem;
//           color: var(--white);
//           line-height: 1.7;
//           margin-bottom: 28px;
//           max-width: 640px;
//         }

//         /* Revenue stage sequence */
//         .nx-stage-grid {
//           display: flex;
//         }
//         .nx-stage {
//           flex: 1;
//           padding: 0 28px;
//         }
//         .nx-stage:first-child {
//           padding-left: 0;
//         }
//         .nx-stage:last-child {
//           padding-right: 0;
//         }
//         .nx-stage:not(:first-child) {
//           border-left: 1px solid rgba(255, 255, 255, 0.1);
//         }
//         .nx-stage-num {
//           font-family: 'Founders Grotesk', sans-serif;
//           font-size: 2.4rem;
//           font-weight: 700;
//           line-height: 1;
//           color: var(--gold);
//           opacity: 0.28;
//           margin-bottom: 12px;
//         }
//         .nx-stage-name {
//           font-size: .95rem;
//           font-weight: 700;
//           color: var(--white);
//           margin-bottom: 10px;
//           font-family: 'Founders Grotesk', sans-serif;
//         }
//         .nx-stage-text {
//           font-size: .82rem;
//           line-height: 1.7;
//           color: rgba(255, 255, 255, 0.65);
//           margin-bottom: 0;
//         }

//         @media (max-width: 991px) {
//           .nx-stage-grid {
//             flex-direction: column;
//           }
//           .nx-stage {
//             padding: 24px 0 !important;
//             border-left: none !important;
//           }
//           .nx-stage:first-child {
//             padding-top: 0 !important;
//           }
//           .nx-stage:not(:first-child) {
//             border-top: 1px solid rgba(255, 255, 255, 0.1);
//           }
//         }

//         /* Use of proceeds */
//         .nx-proceeds-row {
//           margin-bottom: 18px;
//         }
//         .nx-proceeds-row:last-child {
//           margin-bottom: 0;
//         }
//         .nx-proceeds-label {
//           font-size: .82rem;
//           color: var(--white);
//         }
//         .nx-proceeds-value {
//           font-size: .92rem;
//           font-weight: 700;
//           color: var(--gold);
//           font-family: 'Founders Grotesk', sans-serif;
//         }
//         .nx-proceeds-track {
//           height: 6px;
//           border-radius: 3px;
//           background: rgba(255, 255, 255, 0.08);
//           overflow: hidden;
//         }
//         .nx-proceeds-fill {
//           height: 100%;
//           border-radius: 3px;
//           background: var(--gold);
//           transition: width 1.1s cubic-bezier(0.16, 1, 0.3, 1);
//         }

//         /* Milestones timeline */
//         .nx-milestones {
//           margin-top: 4px;
//         }
//         .nx-milestone-row {
//           display: flex;
//           gap: 16px;
//         }
//         .nx-milestone-marker {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           width: 10px;
//           flex-shrink: 0;
//         }
//         .nx-milestone-dot {
//           width: 10px;
//           height: 10px;
//           border-radius: 50%;
//           background: var(--gold);
//           flex-shrink: 0;
//           margin-top: 4px;
//         }
//         .nx-milestone-line {
//           flex: 1;
//           width: 1px;
//           background: rgba(255, 255, 255, 0.15);
//           margin-top: 4px;
//         }
//         .nx-milestone-content {
//           padding-bottom: 26px;
//         }
//         .nx-milestone-row:last-child .nx-milestone-content {
//           padding-bottom: 0;
//         }
//         .nx-milestone-phase {
//           font-size: .72rem;
//           letter-spacing: .14em;
//           text-transform: uppercase;
//           color: var(--gold);
//           font-weight: 700;
//           margin-bottom: 6px;
//           font-family: 'Founders Grotesk', sans-serif;
//         }
//         .nx-milestone-text {
//           font-size: .92rem;
//           color: var(--white);
//         }
//       `}</style>
//     </section>
//   );
// }

// export default Summary;

import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

import "./summary.css";
import { motion } from 'motion/react';
import Timeline from './timeline'
const STAGES = [
  {
    num: "01",
    name: "Acquire",
    text:
      "With our agreement, we have a ready pipeline source for acquisitions and a base for growth. Most of the assets we acquire will be newer billboards potentially under 3 years old with 50 year land leases. "
  },
  {
    num: "02",
    name: "Mature the Assets",
    text:
      "Our operator has well over a decade of experience in this space. The assets will plan to mature over an 18 – 36 month window. Common industry normalization is around 75% filled capacity."
  },
  {
    num: "03",
    name: "Consistent Growth",
    text:
      "Once billboards are in place, the planned revenue growth is consistent at 3% – 7% per year per contract. "
  },
  {
    num: "04",
    name: "Sale",
    text:
      "When the time is right, the operator intends to purchase back the assets. In the process a realization of two additional turns will happen – creating a profitable cash lump sum to investors."
  }
];


const PROCEEDS = [
  { label: "Purchase of Billboard Assets over 12 month period", percent: 95 },
  { label: "Estimated Closing costs, Permits, Taxes, Site maintenance and repair costs, and other Asset related Fees", percent: 3.5 },
  { label: "Legal Fees", percent: 1 },
  { label: "Marketing Costs", percent: 0.5 },
  // { label: "lorem ipsum", percent: 10 }
];


const MILESTONES = [
  { phase: "Months 1–12", text: "Purchase Billboards over 12 month period for Fund One" },
  { phase: "Months 6-72", text: "Manage Billboards and plan to return distributions to investors on a quarterly basis" },
  { phase: "Months 42-72", text: "Sale of Billboards, plan to return proceeds of sale to investors" },
  // { phase: "Months 25–36", text: "lorem ipsum" }
];


function useInView(threshold = 0.35) {

  const ref = useRef(null);

  const [inView, setInView] = useState(false);


  useEffect(() => {

    const el = ref.current;

    if (!el) return;


    const observer = new IntersectionObserver(

      ([entry]) => {

        if (entry.isIntersecting) {

          setInView(true);

          observer.disconnect();

        }

      },

      { threshold }

    );


    observer.observe(el);

    return () => observer.disconnect();

  }, [threshold]);


  return [ref, inView];

}


function Summary() {

  const [proceedsRef, proceedsInView] = useInView(0.3);


  return (

    <motion.section id="business" className="summary-section"
     initial={{
        opacity: 0,
        y: 50
      }}

      whileInView={{
        opacity: 1,
        y: 0
      }}

      transition={{
        duration: 0.8,
        ease: 'easeOut'
      }}

      viewport={{
        once: true,
        amount: 0.2
      }}
    >


      {/* Background accents */}

      <div className="summary-glow summary-glow-left"></div>

      <div className="summary-glow summary-glow-right"></div>


      <Container className="position-relative">


        {/* SECTION HEADER */}

        <div className="summary-header">

          <div className="section-label summary-label">

            <span className="summary-label-line"></span>

            BUSINESS SUMMARY

          </div>


          <h2 className="section-title summary-title">

            Strategy &amp; Operations

          </h2>


          <div className="summary-title-line"></div>

        </div>


        <Row className="g-4 mt-2">


          {/* =====================================
              REVENUE GROWTH STRATEGY
          ====================================== */}

          <Col lg={12}>

            <div className="business-card summary-card fade-up">

              <div className="summary-card-top">

                <div>

                  <div className="summary-card-label">
                    GROWTH FRAMEWORK
                  </div>

                  <h5 className="nx-eyebrow">
                    Revenue Growth Strategy
                  </h5>

                </div>

                <div className="summary-card-icon">
                  ↗
                </div>

              </div>


              <p className="nx-intro">

                Boch's revenue growth strategy is designed around
                four primary stages.

              </p>


              <div className="nx-stage-grid">

                {STAGES.map((stage) => (

                  <div
                    className="nx-stage"
                    key={stage.num}
                  >

                    <div className="nx-stage-top">

                      <div className="nx-stage-num">
                        {stage.num}
                      </div>

                      <div className="nx-stage-indicator"></div>

                    </div>


                    <div className="nx-stage-name">

                      {stage.name}

                    </div>


                    <p className="nx-stage-text">

                      {stage.text}

                    </p>

                  </div>

                ))}

              </div>

            </div>

          </Col>


          {/* =====================================
              USE OF PROCEEDS
          ====================================== */}

          <Col lg={6}>

            <div
              className="business-card summary-card fade-up"
              ref={proceedsRef}
            >

              <div className="summary-card-top">

                <div>

                  <div className="summary-card-label">
                    CAPITAL ALLOCATION
                  </div>

                  <h5 className="nx-eyebrow">
                    Use of Proceeds
                  </h5>

                </div>


                <div className="summary-card-icon">
                  %
                </div>

              </div>


              <div className="nx-proceeds-list">

                {PROCEEDS.map(({ label, percent }) => (

                  <div
                    key={label}
                    className="nx-proceeds-row"
                  >

                    <div className="d-flex justify-content-between align-items-baseline mb-2">

                      <span className="nx-proceeds-label">

                        {label}

                      </span>


                      <span className="nx-proceeds-value">

                        {percent}%

                      </span>

                    </div>


                    <div className="nx-proceeds-track">

                      <div
                        className="nx-proceeds-fill"
                        style={{
                          width: proceedsInView
                            ? `${percent}%`
                            : "0%"
                        }}
                      />

                    </div>

                  </div>

                ))}

              </div>

            </div>

          </Col>


          {/* =====================================
              DEVELOPMENT MILESTONES
          ====================================== */}

          <Col lg={6}>

            <div className="business-card summary-card fade-up">

              <div className="summary-card-top">

                <div>

                  <div className="summary-card-label">
                    EXECUTION ROADMAP
                  </div>

                  <h5 className="nx-eyebrow">
                    Development Milestones
                  </h5>

                </div>


                <div className="summary-card-icon">
                  →
                </div>

              </div>


              <div className="nx-milestones">

                {MILESTONES.map((m, i) => (

                  <div
                    className="nx-milestone-row"
                    key={m.phase}
                  >

                    <div className="nx-milestone-marker">

                      <span className="nx-milestone-dot" />

                      {i !== MILESTONES.length - 1 && (

                        <span className="nx-milestone-line" />

                      )}

                    </div>


                    <div className="nx-milestone-content">

                      <div className="nx-milestone-phase">

                        {m.phase}

                      </div>


                      <div className="nx-milestone-text">

                        {m.text}

                      </div>

                    </div>

                  </div>

                ))}

              </div>

            </div>

          </Col>

        </Row>

      </Container>

    </motion.section>

  );

}


export default Summary;
